export default __webpack_public_path__ + "static/media/logo-light.50d9a64d.png";